import React, { createContext, useContext } from "react";

const LinkedInAuthContext = createContext();


export const LinkedInAuthProvider = ({ children }) => {
  const loginWithLinkedIn = () => {
    // const clientId = process.env.REACT_APP_LINKDIN_CLIENT_ID;
    const redirectUri = `${window.location.origin}/linkedin/callback`;
    const state = crypto.randomUUID();
    localStorage.setItem("linkedin_csrf", state);

    const scope = "openid profile email";
    const loginUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKDIN_CLIENT_ID}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&state=${state}&scope=${encodeURIComponent(scope)}`;

    window.location.href = loginUrl;
  };


  return (
    <LinkedInAuthContext.Provider value={{ loginWithLinkedIn }}>
      {children}
    </LinkedInAuthContext.Provider>
  );
};

export const useLinkedInAuth = () => useContext(LinkedInAuthContext);